module Meevo.Components.Controls {

    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;

    export class MeevoPagerController extends ShortCutsStateManagerController {
        static $inject = [
            '$scope',
            '$state',
            'meevo.components.short-cuts.ShortCutsService'
        ];

        shortCutGroup: IShortCutGroup | { [key: number]: IShortCutGroup };

        get noun() {
            if (!this.$scope.context.selectedSection) {
                return null;
            }
            
            return this.$scope.context.selectedSection.noun;
        }

        get mode(): Meevo.Model.MaintenanceFormState {
            return this.$scope.context ? this.$scope.context.mode : Meevo.Model.MaintenanceFormState.Readonly;
        }

        constructor(
            protected $scope: any,
            protected $state: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService
        ) {
            super($scope, $state, shortCutsService);

            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.$scope.context.preventUsageTracking = true;
                        this.$scope.context.edit();
                        this.$scope.context.preventUsageTracking = false;
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.$scope.context.preventUsageTracking = true;
                        this.$scope.submitForm();
                        this.$scope.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.$scope.context.preventUsageTracking = true;
                        this.$scope.context.cancel();
                        this.$scope.context.preventUsageTracking = false;
                    }
                }])
            };
        }
    }

    angular.module('meevo.components.controls')
        .controller('meevo.components.controls.MeevoPagerController', MeevoPagerController)
}